import { mirrorX } from "apparatus/draw";
import { P, Pivot, R, Segments } from "apparatus/library/common";
import { Ray } from "apparatus/library/physics/optical/common";
import { CompoundPath, Group, Path, Shape } from "paper";
const SLIT_PLATE_COLOR = "#555555";
export class RayBox {
    render(appearance) {
        const { slits, slitGap } = appearance;
        const box = new Path(Segments([[30, 0]], [[30, -80]], [[35, -80]], [[35, 60]])).withStroke("default").withFill("#444444").close();
        mirrorX(box);
        const graphic = new Group([box]);
        if (slits !== "none") {
            const slitPlate = new CompoundPath([]).withStroke("default", SLIT_PLATE_COLOR);
            slitPlate.moveTo(P(-30, -65));
            for (let i = 0; i < slits; i++) {
                const dx = ((slits - 1) / -2 + i) * slitGap;
                slitPlate.lineTo(P(dx - 1, -65));
                slitPlate.moveBy(P(2, 0));
            }
            slitPlate.lineTo(P(30, -65));
            graphic.insertChild(0, slitPlate);
        }
        const rayLength = 200;
        if (appearance.showRay) {
            // First draw the glow.
            const hexColor = appearance.rayColor.color().darken(0.1).hex();
            if (slits === "none") {
                graphic.insertChild(0, Shape.Rectangle(R(0, 0, 60, 200, Pivot.BOTTOM_CENTER)).withGradientFill("up", [[hexColor + "aa", 0.5], [hexColor + "00", 1.0]]));
            }
            else {
                graphic.insertChild(0, Shape.Rectangle(R(0, 0, 60, 65, Pivot.BOTTOM_CENTER)).setRadialGradientFill([[hexColor + "aa", 0.5], [hexColor + "40", 1.0]], { center: P(0, 0), edge: P(30, -65) }));
                // Draw rays
                for (let i = 0; i < slits; i++) {
                    const dx = ((slits - 1) / -2 + i) * slitGap;
                    graphic.insertChild(0, new Path.Line(P(dx, -64), P(dx, -(64 + rayLength))).withStroke(appearance.rayThickness, appearance.rayColor));
                }
            }
        }
        return {
            graphic,
            pivot: box.bounds.center,
            hitShape: box.bounds.toShape()
        };
    }
}
RayBox.properties = {
    label: "Ray Box",
    defaultAppearance: Object.assign({ slits: "none", slitGap: 10 }, Ray.defaultAppearanceRayOff),
    appearanceSpecs: [
        {
            spec: "toggle-buttons",
            size: "text",
            label: "Slits",
            key: "slits",
            options: [
                { value: "none", label: "None" },
                { value: 1, label: "1" },
                { value: 3, label: "3" },
            ]
        },
        {
            spec: "slider",
            label: "Gap between slits",
            key: "slitGap",
            min: 10, max: 20, step: 1,
            visible: (appearance) => appearance.slits !== "none" && appearance.slits >= 2,
            tier: "boost",
        },
        ...Ray.specs
    ],
};
